import type { ConversationRecord } from "@opencloud/agent-protocol";
import { useEffect, useState } from "react";
import { listConversations } from "./conversations-api.js";

/** Current access and next-run payer are projected by the service, never inferred from ownership. */
export function useAppConversation(appId: string | null) {
  const [record, setRecord] = useState<ConversationRecord | null | undefined>(undefined);
  useEffect(() => {
    const controller = new AbortController();
    let timer: number | undefined;
    setRecord(undefined);
    if (!appId) return () => controller.abort();
    async function refresh() {
      try {
        const records = await listConversations(controller.signal);
        if (!controller.signal.aborted) setRecord(records.find((item) => item.kind === "app" && item.appId === appId) ?? null);
      } catch {
        if (!controller.signal.aborted) setRecord(undefined);
      } finally {
        if (!controller.signal.aborted) timer = window.setTimeout(() => void refresh(), 5000);
      }
    }
    void refresh();
    return () => { controller.abort(); if (timer !== undefined) window.clearTimeout(timer); };
  }, [appId]);
  return record === undefined ? undefined : record?.appId === appId ? record : null;
}
